import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'td-wb-slider-item',
  template: '<ng-content />',
  styleUrls: ['slider-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SliderItemComponent {
}
